import {
  formatNormalNumber,
  createKpiTileItem,
  formatPercentageValue,
} from '../../../../utils/helper';

export default {
  type: 'KpiTile',
  handler: (data) => {
    const { activeBU, activeBUDelta } = data.getPOReachMetrics;

    return createKpiTileItem(
      "Active BU's",
      formatNormalNumber(activeBU),
      activeBUDelta !== null && activeBUDelta !== undefined
        ? {
            isPositiveValue: activeBUDelta >= 0,
            text: formatPercentageValue(Math.abs(activeBUDelta)),
            sideLabel: '',
            showArrow: Number(activeBUDelta) !== 0,
          }
        : null
    );
  },
};
